import React, { useMemo, useState, useEffect } from 'react';
import { Alert, AlertTitle, Button, Collapse, Box, Stack } from '@mui/material';
import { useLocation } from 'react-router-dom';

const PLAY_URL = 'https://play.google.com/store/apps/details?id=app.tucar.driver.twa';
const APPLE_URL = 'https://apps.apple.com/cl/app/tucar/id6749870114';

const getPlatform = () => {
  const ua = (typeof navigator !== 'undefined' ? navigator.userAgent : '').toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) return 'ios';
  if (/android/.test(ua)) return 'android';
  return 'other';
};

export default function UpdateNativeBanner() {
  const [open, setOpen] = useState(false);
  const platform = useMemo(getPlatform, []);
  const location = useLocation();

  useEffect(() => {
    const shown = sessionStorage.getItem('updateBannerShown');
    if (shown) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [location.pathname]);

  const handleClose = () => {
    setOpen(false);
    sessionStorage.setItem('updateBannerShown', 'true');
  };

  let targetUrl;
  if (platform === 'android') {
    targetUrl = PLAY_URL;
  } else if (platform === 'ios') {
    targetUrl = APPLE_URL;
  } else {
    targetUrl = undefined;
  }

  return (
    <Collapse in={open} sx={{ position: 'fixed', top: 0, zIndex: (t) => t.zIndex.appBar + 1 }}>
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: (t) => t.zIndex.appBar + 1,
          px: 2,
          pt: 2,
          backgroundColor: 'transparent',
        }}
      >
        <Alert
          severity="warning"
          onClose={handleClose}
          sx={{
            borderRadius: 2,
            boxShadow: 1,
          }}
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'stretch', sm: 'center' }}
            spacing={1}
            justifyContent="space-between"
          >
            <Box flex={1} pr={{ sm: 2 }} sx={{ textAlign: 'justify' }}>
              <AlertTitle sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
                Cambios en nuestra aplicación
              </AlertTitle>
              Desde el 13 de octubre, la visualización completa de perfiles solo estará disponible
              en la aplicación. La web seguirá activa para visualización de pagos y liquidaciones.
            </Box>

            {targetUrl ? (
              <Button
                variant="contained"
                onClick={() => {
                  window.location.href = targetUrl;
                }}
              >
                ¡Descárgala ahora!
              </Button>
            ) : (
              <Stack direction="row" spacing={1}>
                <Button
                  variant="contained"
                  onClick={() => {
                    window.location.href = PLAY_URL;
                  }}
                >
                  Play Store
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => {
                    window.location.href = APPLE_URL;
                  }}
                >
                  App Store
                </Button>
              </Stack>
            )}
          </Stack>
        </Alert>
      </Box>
    </Collapse>
  );
}
